export class EditBillItemEmployeeModel {
  public BillItemId: number;
  public BillPackageItemId: number;
}
